import * as React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/utils/common.utils";

interface AppDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: React.ReactNode;
  description?: React.ReactNode;
  eyebrow?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  contentClassName?: string;
  headerClassName?: string;
  testId?: string;
}

export default function AppDialog({ open, onOpenChange, title, description, eyebrow, children, footer, contentClassName, headerClassName, testId }: AppDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={cn("rounded-3xl border-dash-border sm:max-w-lg", contentClassName)} data-testid={testId}>
        <DialogHeader className={headerClassName}>
          <div className="flex items-center gap-2">
            <DialogTitle className="text-xl text-dash-ink">{title}</DialogTitle>
            {eyebrow && <span className="rounded-full bg-dash-hover px-2 py-0.5 text-[11px] font-medium text-dash-greenDeep">{eyebrow}</span>}
          </div>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        {footer && <DialogFooter className="gap-2 sm:gap-2">{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}
